export const ELO_PUBLISHER_OVERVIEW_PATH = '/ablefy_affiliate'
export const ELO_PUBLISHER_PROFILE_PATH = '/ablefy_affiliate/profile/edit'
export const ELO_PUBLISHER_BANK_ACCOUNTS_PATH = '/ablefy_affiliate/bank_accounts'
export const ELO_PUBLISHER_PAYOUTS_PATH = '/ablefy_affiliate/payouts'
export const ELO_PUBLISHER_PAYOUTS_SCHEDULE_PATH = '/ablefy_affiliate/payouts_balance'
export const ELO_PUBLISHER_SUPPORT_PATH = '/ablefy_affiliate/support'
export const ELO_PUBLISHER_ONBOARDING_PATH = '/ablefy_affiliate/onboarding_journey'
export const ELO_PUBLISHER_ONBOARDING_BUSINESS_PATH = '/ablefy_affiliate/onboarding_journey/business_information'
export const ELO_PUBLISHER_ONBOARDING_VERIFICATION_PATH = '/ablefy_affiliate/onboarding_journey/verification'
export const ELO_PUBLISHER_ONBOARDING__PAYOUT_PATH = '/ablefy_affiliate/onboarding_journey/payout_details'
export const ELO_PUBLISHER_SIGN_IN_PARAM = '?profile_type=ablefy_affiliate'
export const ELO_PUBLISHER_NOT_FOUND_PATH = '*'
